// URL Services
export const URL_SERVICE = process.env.ENVIRONMENT === 'staging' ?
    'https://39yz4ux8li.execute-api.us-east-1.amazonaws.com/stg' :
    process.env.ENVIRONMENT === 'production' ? 'https://6th8tjuild.execute-api.us-east-1.amazonaws.com/pdn' :
        'https://qc0wch4phk.execute-api.us-east-1.amazonaws.com/dev';

// Get ip Address
export const GET_IP_ADDRESS = 'https://jsonip.com/';
